import $ from 'jquery';

function highlightRequired($elem, has_data) {

  if (has_data) {
    $elem.closest('.form-group')
      .removeClass('has-error');
  }
  else {
    $elem.closest('.form-group')
      .addClass('has-error');
  }
}

class Acknowledgement {

  constructor() {
  }

  init() {
    this.$modal = $('#acknowledgementModal');
    this.$client_contact = this.$modal.find('#client_contact');
    this.$other_contact = this.$modal.find('#other_contact');
    this.$other_contact_block = this.$modal.find('#other_contact_block');
    this.$other_first_name = this.$modal.find('#other_first_name');
    this.$other_last_name = this.$modal.find('#other_last_name');
    this.$other_phone = this.$modal.find('#other_phone');
    this.$other_email = this.$modal.find('#other_email');
    this.$add_other_to_contacts = this.$modal.find('#add_other_to_contacts');
    this.$note = this.$modal.find('#note');
    this.$send_button = this.$modal.find('#button_send_acknowledgement');
    this.$preview_button = this.$modal.find('#button_preview_acknowledgement');

    this.$send_button.prop('disabled', true);

    this.initialHighlights();
    this.validate();
    this.buildPreviewUrl();
    //    this.$modal.modal('show');
  }

  presentOtherContactBlock() {
    this.$other_contact_block
      .hide()
      .removeClass('d-none')
      .slideDown('fast');

    highlightRequired(this.$client_contact, true);
  }

  hideOtherContactBlock() {
    this.$other_contact_block
      .slideUp('fast');

    this.$other_first_name.val('');
    this.$other_last_name.val('');
    this.$other_phone.val('');
    this.$other_email.val('');
    this.$add_other_to_contacts.prop('checked', false);

    highlightRequired(this.$client_contact, false);
  }

  toggleOtherContactBlock() {
    if (this.$other_contact.prop('checked')) {
      this.presentOtherContactBlock();
    }
    else {
      this.hideOtherContactBlock();
    }
  }

  buildPreviewUrl() {

    let baseUrl = this.$preview_button.data('href');
    let input = {
      input: {
        contact: {
          ids: this.$client_contact.val(),
          first_name: this.$other_first_name.val(),
          last_name: this.$other_last_name.val(),
          phone: this.$other_phone.val(),
          email: this.$other_email.val(),
        },
        note: this.$note.val()
      }
    };

    let qs = $.param(input);
    let url = baseUrl + '?' + qs;
    this.$preview_button.attr('href', url);
  }

  setupEvents() {
    let _this = this;

    this.$other_contact.on('click', function () {
      _this.toggleOtherContactBlock();
      _this.buildPreviewUrl();

      _this.validate();
    });

    this.$client_contact.on('change', function () {
      let $this = $(this);
      let value = $.trim($this.val());

      highlightRequired($this, !!value.length);

      _this.buildPreviewUrl();
      _this.validate();
    });


    this.$other_first_name.on('input', function () {
      let $this = $(this);
      let value = $.trim($this.val());

      highlightRequired($this, !!value.length);
      _this.validate();
      _this.buildPreviewUrl();
    });

    this.$other_last_name.on('input', function () {
      let $this = $(this);
      let value = $.trim($this.val());

      highlightRequired($this, !!value.length);
      _this.validate();
      _this.buildPreviewUrl();
    });

    this.$other_email.on('input', function () {
      let $this = $(this);
      let value = $.trim($this.val());

      highlightRequired($this, !!value.length);
      _this.validate();
      _this.buildPreviewUrl();
    });

    this.$other_phone.on('input', function () {
      _this.buildPreviewUrl();
    });

    this.$note.on('input', function () {
      _this.buildPreviewUrl();
    });
  }

  initialHighlights() {
    if (this.$other_contact.prop('checked')) {
      let first_name = $.trim(this.$other_first_name.val());
      let last_name = $.trim(this.$other_last_name.val());
      let email = $.trim(this.$other_email.val());

      highlightRequired(this.$other_first_name, !!first_name.length);
      highlightRequired(this.$other_last_name, !!last_name.length);
      highlightRequired(this.$other_email, !!email.length);
      highlightRequired(this.$client_contact, true);
    }
    else if (this.$client_contact) {
      let client_contact = $.trim(this.$client_contact.val());
      highlightRequired(this.$client_contact, !!client_contact.length);
    }
  }

  validate() {
    // this.$modal.find('.form-control.needs-validation').each(function() {
    //   let $this = $(this);
    //   let value = $.trim($this.val());
    //
    //   highlightRequired($this, !!value.length);
    // });

    let first_name = $.trim(this.$other_first_name.val());
    let last_name = $.trim(this.$other_last_name.val());
    let email = $.trim(this.$other_email.val());
    let contact_id = $.trim(this.$client_contact.val());

    let valid = !!contact_id.length || (!!first_name.length && !!last_name.length && !!email.length);

    this.$send_button.prop('disabled', !valid);
  }

  load() {
    this.init();
    this.setupEvents();
  }
}

export default new Acknowledgement();
